import { IOpenOrdersResponse, IOrder } from '.';
import { IState } from '..';

export const getSalesOrder = (state: IState, salesId: string): IOrder | undefined => state.order.hash[salesId];

export const getOpenOrdersResponse = ({ order: { openOrders } }: IState): IOpenOrdersResponse => {
  if (openOrders && openOrders.response) {
    return openOrders.response;
  }
  return {
    count: 0,
    dealers: [],
    total: 0
  };
};
